import store from "@/store";

function email() {
  return store.getters['auth/getUserInformation'].email;
}

export {
  email
}



// WEBPACK FOOTER //
// ./src/helpers/auth/index.js